// extracted by mini-css-extract-plugin
export default {"strip":"fQSW1"};